import { PipeTransform } from '@angular/core';
var FirstLetterUpperPipe = /** @class */ (function () {
    function FirstLetterUpperPipe() {
    }
    FirstLetterUpperPipe.prototype.transform = function (word) {
        if (!word || typeof (word) === 'number')
            return word;
        return word[0].toUpperCase() + word.substr(1).toLowerCase();
    };
    return FirstLetterUpperPipe;
}());
export { FirstLetterUpperPipe };
